module.exports = __webpack_public_path__ + "static/media/beginning_of_lesson.ba4cb555.svg";